import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Gauge } from "lucide-react";

interface ConfidenceSelectorProps {
  value: number | null;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const LABELS: Record<number, string> = {
  1: "Guessing",
  2: "Unsure",
  3: "Maybe",
  4: "Confident",
  5: "Certain",
};

export const ConfidenceSelector = ({ value, onChange, disabled }: ConfidenceSelectorProps) => {
  return (
    <div className="rounded-lg border border-border bg-muted/30 p-3">
      <div className="flex items-center gap-2 mb-2">
        <Gauge className="h-4 w-4 text-primary" />
        <span className="text-sm font-medium text-foreground">How confident are you?</span>
        {value && (
          <span className="ml-auto text-xs text-muted-foreground">{LABELS[value]}</span>
        )}
      </div>
      <div className="grid grid-cols-5 gap-2">
        {[1, 2, 3, 4, 5].map((n) => (
          <Button
            key={n}
            type="button"
            size="sm"
            variant={value === n ? "default" : "outline"}
            disabled={disabled}
            onClick={() => onChange(n)}
            className={cn(
              "h-9 text-xs font-semibold",
              value === n && "bg-gradient-medical"
            )}
            aria-label={`Confidence ${n} of 5: ${LABELS[n]}`}
          >
            {n}
          </Button>
        ))}
      </div>
    </div>
  );
};
